<template>
  <v-card class="core-toolbar overflow-hidden">
    <v-app-bar
      fixed
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-toolbar-title class="ml-12">PARTICIPA INTELIGENTE</v-toolbar-title>
      <v-list-item-content>
        <!--
          <v-img
            height="50"
            width="10"
            src="../../assets/img/logotipo-celp-con-inedita.png"
          ></v-img>
        -->
      </v-list-item-content>

      <v-spacer></v-spacer>
      <v-btn text small color="primary" @click="changeToInit">Inicio</v-btn>
      <v-btn text small color="primary" @click="changeToProjectList"
        >Proyectos</v-btn
      >
      <v-btn text small color="primary" @click="changeToProject"
        >Como funciona</v-btn
      >
      <v-btn text small color="primary" @click="changeToInformation"
        >Quienes somos</v-btn
      >
      <v-btn text small color="primary" @click="changeToContact"
        >Contacto</v-btn
      >
      <v-spacer></v-spacer>

      <v-btn small color="primary" v-if="!logged" @click="changeToLogin"
        >Iniciar Sesión</v-btn
      >
    </v-app-bar>
    <v-sheet
      id="scrolling-techniques-7"
      class="overflow-y-auto"
      max-height="600"
    >
      <v-container style="height: 60px;"></v-container>
    </v-sheet>
  </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import { auth } from "firebase";

export default {
  data: () => ({
    logged: false,
    notifications: [],
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    $route(val) {
      this.title = val.name;
    }
  },

  mounted() {
    if (auth().currentUser !== null) {
      this.logged = true;
    }

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClick() {
      // We need to redirect to the notification page
    },

    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },

    changeToInit() {
      if (this.$router.currentRoute.name != "init")
        this.$router.push({ name: "init" });
    },
    changeToProjectList() {
      if (this.$router.currentRoute.name != "projects")
        this.$router.push({ name: "projects" });
    },
    changeToProject() {
      if (this.$router.currentRoute.name != "project")
        this.$router.push({ name: "project" });
    },
    changeToInformation() {
      if (this.$router.currentRoute.name != "aboutus")
        this.$router.push({ name: "aboutus" });
    },

    changeToContact() {
      if (this.$router.currentRoute.name != "contact")
        this.$router.push({ name: "contact" });
    },
    changeToLogin() {
      if (this.$router.currentRoute.name != "login")
        this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
/* @media handheld, only screen and (min-width: 950px) {
  .toolbar-top {
    display: none;
  }
} */
</style>
